module.exports = __webpack_public_path__ + "static/media/spins-bg-image.45ec7773.png";